import { useState } from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { BudgetCardRowV2 } from './BudgetCardRowV2';
import { BudgetaryExerciseActionsBarV2 } from './BudgetaryExerciseActionsBarV2';
import { type BudgetaryExercise } from '../../../../models/budgetaryExercise';
import { type PeriodRange } from '../../../../models/periodRange';
import { sortNamedItems } from '../../../../utils/sortNamedItems';

export type BudgetaryExerciseCardV2Props = {
  budgetaryExercise: BudgetaryExercise;
  canEditBudgets: boolean;
  activeLanguage: string;
  onRowClick: (budgetId: string, expenseCategoryId?: string) => void;
};

export const BudgetaryExerciseCardV2 = ({
  budgetaryExercise,
  canEditBudgets,
  activeLanguage,
  onRowClick,
}: BudgetaryExerciseCardV2Props) => {
  const { t } = useTranslation('global');

  const [periodRange, setPeriodRange] = useState<PeriodRange>({
    key: 'overall',
  });

  const { budgets } = budgetaryExercise;

  const configuredBudgets = sortNamedItems(
    budgets.filter((budget) => !budget.isUnavailable),
    activeLanguage,
  );

  return (
    <div className="box p-0 pb-8">
      <BudgetaryExerciseActionsBarV2
        budgetaryExercise={budgetaryExercise}
        periodRange={periodRange}
        setPeriodRange={setPeriodRange}
        canEditBudgets={canEditBudgets}
      />

      <div className="mb-16 grid w-full grid-cols-4 px-16 pt-16 pl-[54px]">
        <div className="text-content-secondary-bg-primary body-m -ml-40">
          {t('budget.redesigned.budgetName')}
        </div>
        <div className="flex justify-between">
          <div className="text-content-secondary-bg-primary body-m">
            {t('budget.redesigned.utilization')}
          </div>
          <div className="text-content-secondary-bg-primary body-m">
            {t('budget.redesigned.budget')}
          </div>
        </div>
        <div className="text-content-secondary-bg-primary body-m text-right">
          {t('budget.redesigned.committed')}
        </div>
        <div className="text-content-secondary-bg-primary body-m text-right">
          {t('budget.redesigned.availableOrExceeded')}
        </div>
      </div>

      <div className="px-8">
        {configuredBudgets.map((budget) => (
          <BudgetCardRowV2
            key={budget.id}
            budget={budget}
            periodRange={periodRange}
            budgetaryExercise={budgetaryExercise}
            onRowClick={onRowClick}
          />
        ))}
      </div>
    </div>
  );
};
